// extracted by mini-css-extract-plugin
export var column = "google-map-module--column--KT7Tp";
export var map = "google-map-module--map--zHvvp";
export var mapWrapper = "google-map-module--map-wrapper--cdsUA";
export var wrapper = "google-map-module--wrapper--xd1k5";